import { render, staticRenderFns } from "./MasterFooter.vue?vue&type=template&id=4d53d59e"
import script from "./MasterFooter.vue?vue&type=script&lang=js"
export * from "./MasterFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports